import * as actionTypes from "../actions";

const initialState = {
  showModal: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.HANDLE_AUTH_MODAL:
      return {
        showModal: action.payload.showModal,
      };
    default:
      return state;
  }
};

export default authReducer;

// export const authInitialState = {
//   isLoggedIn: false,
//   user: null,
// };

// export function authReducer(state, action) {
//   switch (action.type) {
//     case "LOGIN":
//       return { isLoggedIn: true, user: action.payload };
//     case "LOGOUT":
//       return { isLoggedIn: false, user: null };
//     default:
//       return state;
//   }
// }
